import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import axios from "axios";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useZonePageDocumentDetails } from "../Zone.hooks";
import { useLocalStorage } from "~/Hooks/useLocalStorage";

export const AddEditPublic = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [parentId, setParentId] = useState<any>();
  const [parentName, setParentName] = useState<any>();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editPageContent,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useZonePageDocumentDetails(query.get("editId") || "");

  const {
    data: editPageContentById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");
  const getParentRecords = () => {
    let url = `${passengerHost}/api/zonelevel-parent`;
    axios
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          const filtered = envelopes.filter(
            (item: any) => item.name === "Public" && (item.parent_term_id === "" || item.parent_term_id === null)
          );
          setParentId(filtered?.[0]?.id);
          setParentName(filtered?.[0]?.name);
        }
      })
      .catch((err) => {
        setParentId(null);
        setParentName("");
      });
  };
  useEffect(() => {
    getParentRecords();
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
      name: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name)
        : editPageContent
          ? decodeHTML(editPageContent?.name)
          : "",

      name_ms: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_ms)
        : editPageContent
          ? decodeHTML(editPageContent?.name_ms)
          : "",

      name_zh: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_zh)
        : editPageContent
          ? decodeHTML(editPageContent?.name_zh)
          : "",

      published: editPageContentById
        ? editPageContentById.payload?.published
        : editPageContent
          ? editPageContent?.published
          : false,
      airports: (decodeHTML(editPageContentById?.payload?.airports) || decodeHTML(editPageContent?.airports) || "")
        .split(",")
        .map((a: any) => a.trim())
        .filter(Boolean),
    },
    fields: fields.zonePublic,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (Array.isArray(data.airports)) {
      data.airports = data.airports.join(", ");
    }

    const payload = {
      action,
      method,
      module: "Shop & Dine",
      subModule: "zone_zonePublic",
      airportName: currentAirport,
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageContent?.id || editPageContentById?.payload?.id,
        }),
        ...data,
        parent_term_id: parentId,
        parent_term_name: parentName,
        airport: currentAirport
      },
      status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Zone Public`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/get-zone-level/${editPageContent?.id || editPageContentById?.payload?.id}` : `${passengerHost}/api/create-zone-level`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Shop & Dine"
      />
    </ContentWrapper>
  );
};
